import React, { useRef, useEffect, useState } from "react";
import { Swiper } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { FreeMode, Navigation } from "swiper/modules";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";  // Importing react-icons

const MultiSwiper = ({ children, reffs }) => {
  const [isDisabled, setIsDisabled] = useState({ prev: true, next: false });
  const swiperRef = useRef({});

  useEffect(() => {
    if (swiperRef.current[reffs]) {
      const swiperInstance = swiperRef.current[reffs];
      
      // Update the disabled state based on swiper progress
      swiperInstance.on('slideChange', () => {
        setIsDisabled({
          prev: swiperInstance.isBeginning,
          next: swiperInstance.isEnd,
        });
      });
    }
  }, [reffs]);

  return (
    <div className="max-w-4xl mx-auto relative">
      <Swiper
        onSwiper={(swiperInstance) => {
          swiperRef.current[reffs] = swiperInstance;
        }}
        slidesPerView={3}
        spaceBetween={10}
        freeMode={true}
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 5,
          },
          1024: {
            slidesPerView: 5,
          },
        }}
        navigation={{
          prevEl: `.swiper-button-prev-${reffs}`,
          nextEl: `.swiper-button-next-${reffs}`,
        }}
        pagination={{
          clickable: false,
        }}
        modules={[FreeMode, Navigation]}
        className="mySwiper"
      >
        {children}
      </Swiper>

      {/* Prev button */}
      <div
        className={`swiper-button-prev-${reffs} absolute top-1/2 -left-6 md:-left-12 transform -translate-y-1/2 z-10 bg-primary text-white rounded-full w-10 h-10 flex items-center justify-center cursor-pointer ${isDisabled.prev ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-700'}`}
      >
        <MdChevronLeft size={24} /> {/* react-icon for Left Arrow */}
      </div>

      {/* Next button */}
      <div
        className={`swiper-button-next-${reffs} absolute top-1/2 -right-6 md:-right-12 transform -translate-y-1/2 z-10 bg-primary text-white rounded-full w-10 h-10 flex items-center justify-center cursor-pointer ${isDisabled.next ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-700'}`}
      >
        <MdChevronRight size={24} /> {/* react-icon for Right Arrow */}
      </div>
    </div>
  );
};

export default MultiSwiper;
